const DefaultLandingPage = () => {
  return (
    <div style={{ paddingLeft: "20px" }}>
      <h1>Welcome to Yapi Forms App</h1>
      <p>
        If you got here from scanning the url or clicking on the 404 page to go
        home.
      </p>
      <p>Please try scanning or pasting the url again.</p>
    </div>
  );
};
export default DefaultLandingPage;
